module.exports = __webpack_public_path__ + "img/3.22ab994e.jpg";